export default __webpack_public_path__ + "static/media/glitter-logo.b5ca1fa9.png";